export default __webpack_public_path__ + "static/japanese-encephalitis-0c800173c85f303bfa274f11999a5707.png";